import { editTodo } from "../actions";

const updateTodoText = (todoId, todoText) => {
  return async (dispatch) => {
    const response = await fetch(
      `https://infinite-plains-07870.herokuapp.com/todos/${todoId}`,
      {
        method: "PATCH",
        body: JSON.stringify({
          text: todoText,
        }),
        headers: { "content-type": "application/json" },
      }
    );
    const todo = await response.json();
    dispatch(editTodo(todo.id, todo.text));
  };
};

export default updateTodoText;
